(function () {
    angular.module('directives').directive('hLazyLoad', [function () {
        return {
            restrict: 'A',
            scope: {
                onReach: '&onReach',
                name: "@",
            },
            link: function (scope, element) {
                var $target = $(window);
                var loaded = false;
                var scrollTimer = null;
                var inViewPort = function () {
                    if (loaded) {
                        return;
                    }
                    clearTimeout(scrollTimer);

                    scrollTimer = setTimeout(function () {
                        var rect = element[0].getBoundingClientRect();
                        if (($target.height() + $target.scrollTop() + 300) >= rect.top) {
                            loaded = true;
                            scope.onReach();
                        }
                    }, 50);
                };

                $target.on('scroll.' + scope.name, inViewPort);

                scope.$on('$destroy', function () {
                    $target.off('scroll.' + scope.name);
                    clearTimeout(scrollTimer);
                });
            }
        };
    }]);
})();